<template>
  <!-- 抽奖或者送优惠券 -->
  <div>
    <div v-if="deliverList.length > 0">
      <div class="deliverWrap" v-for="(item, index) in deliverList" :key="index">
        <div class="deliverMark" @click="clickmark(item)">
          <span>{{item.matchedPatternMessage}}</span>
          <img style="width:.14rem;height:.14rem;margin-left:.03rem;" src="../assets/Vector.png" />
        </div>
        <img v-if="item.type == 1" class="delivertextImg" src="../assets/prizeImg.png" alt="">
        <img v-if="item.type == 2" class="delivertextImg" src="../assets/couponImg.png" alt="">
        <div class="deliverContent" @click="goDetail(item)">
          <div class="deliverContenttext">{{item.info}}</div>
          <img v-if="item.type == 1" class="deliverContentright" src="../assets/arrowright.png" alt="">
        </div>
      </div> 
    </div>
    <div class="markBox" v-if="maskVisible" ref="mask" @click="maskClick($event)">
      <div class="content" v-if="rowlist.matchedPatternMessage == '下单赠抽大奖'">
        <div class="topfenge"></div>
        <div class="title">{{textone.title}}</div>
        <pre class="texts">{{textone.texts}}</pre>
      </div>
      <div class="content" v-else-if="rowlist.matchedPatternMessage == '下单赠抽奖外奖'">
        <div class="topfenge"></div>
        <div class="title">{{texttwo.title}}</div>
        <pre class="texts">{{texttwo.texts}}</pre>
      </div>
      <div class="content" v-else-if="rowlist.matchedPatternMessage == '下单赠券'">
        <div class="topfenge"></div>
        <div class="title">{{textthree.title}}</div>
        <pre class="texts">{{textthree.texts}}</pre>
      </div>
      <div class="content" v-else-if="rowlist.matchedPatternMessage == '下单赠惊喜券'">
        <div class="topfenge"></div>
        <div class="title">{{textfour.title}}</div>
        <pre class="texts">{{textfour.texts}}</pre>
      </div>
      <div class="content" v-else-if="rowlist.matchedPatternMessage == '下单赠回馈券'">
        <div class="topfenge"></div>
        <div class="title">{{textfive.title}}</div>
        <pre class="texts">{{textfive.texts}}</pre>
      </div>
      <div class="content" v-else-if="rowlist.matchedPatternMessage == '下单赠惊喜回馈券'">
        <div class="topfenge"></div>
        <div class="title">{{textsix.title}}</div>
        <pre class="texts">{{textsix.texts}}</pre>
      </div>
      <div class="content" v-else-if="rowlist.title == '分享获奖'">
        <div class="topfenge"></div>
        <div class="title">{{textseven.title}}</div>
        <pre class="texts">{{textseven.texts}}</pre>
      </div>
    </div>
    <div class="deliverWrap" v-if="shareList && shareList.exist">
      <div class="deliverMark" @click="clickmark(shareList)">
        <span>{{shareList.title}}</span>
        <img style="width:.14rem;height:.14rem;margin-left:.03rem;" src="../assets/Vector.png" />
      </div>
      <div style="display: flex;align-items:center;padding:.1rem 0 .05rem 0;">
        <img class="delivertextImg" src="https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/225/7eecbe2d-36d5-431a-903b-a8313d4b815f.png?height=30&width=142&size=5" alt="">
        <div class="goshare" @click="gosharelist">
          <img style="width:.14rem;height:.14rem;" src="../assets/share.png" mode=""/>
          <div style="font-size:.12rem;color:#fff;margin:0 .05rem;">查看分享奖励</div>
          <img style="width:.16rem;height:.16rem;" src="../assets/gogogo.png" mode=""/>
        </div>
      </div>
      <div class="deliverContent" @click="gosharelist(item)">
        <div class="deliverContenttext" v-for="(item, index) in shareList.info" :key="index">{{item}}</div>
        <img class="deliverContentright" src="../assets/arrowright.png" alt="">
      </div>
    </div>
    <div v-if="saleList">
      <block v-if="saleList.limits">
        <div class="deliverWrap" v-for="(item, index) in saleList.limits" :key="index">
          <img v-if="item.type == 2" class="typeName" src="../assets/tnum.png" alt="">
          <img v-else class="typeName" src="../assets/dnum.png" alt="">
          <!-- <div class="typeName">{{item.typeName}}</div> -->
          <div class="deliverContent">
            <div class="deliverContenttext">{{item.description}}</div>
          </div>
        </div> 
      </block>
      <block v-if="saleList.sales">
        <div class="deliverWrap" v-for="(item, index) in saleList.sales" :key="index">
          <img v-if="item.type == 2" class="delivertextImg" src="../assets/times.png" alt="">
          <img v-else class="delivertextImg" src="../assets/first.png" alt="">
          <!-- <div class="typeName">{{item.typeName}}</div> -->
          <!-- <img class="delivertextImg" src="../assets/prizeImg.png" alt=""> -->
          <div class="deliverContent">
            <div class="deliverContenttext">{{item.description}}</div>
          </div>
        </div>
      </block>
    </div>
  </div>
</template>

<script>
import { isIos, isAndroid } from '../utils/device'
import prefix from '../utils/prefix'
export default {
  name: 'DeliverView',
  props: {
    deliverList: {
      type: Array,
      default: () => []
    },
    shareList: {
      type: Object,
      default: () => {}
    },
    sharetoken:{
      type: String,
      default: () => ''
    },
    saleList: {
      type: Object,
      default: () => {}
    },
    saletoken:{
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      maskVisible: false,
      rowlist: {},
      textone:{
        title:'下单赠抽大奖',
        texts: `1）当商品绑定多个消费门槛转盘时，用户参与组队且单笔订单实付额同时满足多个转盘门槛时，优先折算参与高门槛转盘，折算后金额不足高门槛转盘但满足其他门槛转盘的，可以继续折算参与。
                \n例：如果设定商品绑定2个转盘活动：a转盘（单笔实付满518元获得一次转盘机会）、b转盘（单笔实付满100元获得一次抽奖机会）。小超有1笔订单实付666元，则小超可以参与1次a转盘、参与1次b转盘。
                \n2）转盘活动规则详见转盘页面。
                \n3）若您未理解本活动，请咨询客服微信：chaojicangku0001、supervault0002或chaojicangku003。`
      },
      texttwo:{
        title:'下单赠抽奖外奖',
        texts: `1）当商品绑定多个消费门槛转盘时，用户参与组队且单笔订单实付额同时满足多个转盘门槛时，可以同时参与满足门槛的转盘。
                \n例：如果设定商品绑定2个转盘活动：a转盘（单笔实付满518元获得一次转盘机会）、b转盘（单笔实付满100元获得一次抽奖机会）。小超有1笔订单实付666元，则小超可以参与1次a转盘、参与6次b转盘。
                \n2）转盘活动规则详见转盘页面。
                \n3）若您未理解本活动，请咨询客服微信：chaojicangku0001、supervault0002或chaojicangku003。`
      },
      textthree:{
        title:'下单赠券',
        texts: `1）用户参与本活动，单笔订单满足实付门槛金额时，系统会自动返还相应优惠券至您的优惠券包。
                \n例：如果设定单笔订单实付满100元，即返10元满减券。假设小超有1笔订单实付220元，则小超自动获得1张10元无门槛优惠券至优惠券包。
                \n2）部分优惠券使用后，订单不参与后续优惠活动（如转盘、订单返券等），您可在“我的→我的优惠券”中查看优惠券详情，具体使用规则和有效时间信息详见券面信息。
                \n3）若您未理解本活动，请咨询客服微信：chaojicangku0001、supervault0002或chaojicangku003。`
      },
      textfour:{
        title:'下单赠惊喜券',
        texts: `1）用户参与本活动，单笔订单每满实付门槛金额时，系统会自动返还相应优惠券至您的优惠券包。
                \n例：如果设定单笔订单实付每满100元，即返10元满减券。假设小超有1笔订单实付220元，则小超自动获得2张10元无门槛优惠券至优惠券包。
                \n2）部分优惠券使用后，订单不参与后续优惠活动（如转盘、订单返券等），您可在“我的→我的优惠券”中查看优惠券详情，具体使用规则和有效时间信息详见券面信息。
                \n3）若您未理解本活动，请咨询客服微信：chaojicangku0001、supervault0002或chaojicangku003。`
      },
      textfive:{
        title:'下单赠回馈券',
        texts: `1）用户参与本活动，单笔订单满足实付门槛金额时，系统会自动返还订单实付金额固定比例无门槛优惠券至您的优惠券包（金额向下取整）。
                \n例：如果设定单笔订单实付满10元，下单立返实付金额10%无门槛优惠券。假设小超有1笔订单实付666元，则小超自动获得1张66元无门槛优惠券至优惠券包。
                \n2）部分优惠券使用后，订单不参与后续优惠活动（如转盘、订单返券等），您可在“我的→我的优惠券”中查看优惠券详情，具体使用规则和有效时间信息详见券面信息。
                \n3）若您未理解本活动，请咨询客服微信：chaojicangku0001、supervault0002或chaojicangku003。`
      },
      textsix:{
        title:'下单赠惊喜回馈券',
        texts: `1）用户参与本活动，单笔订单满足实付门槛金额时，系统会自动返还订单实付金额核定范围内随机比例无门槛优惠券至您的优惠券包（金额向下取整）。
                \n例：如果设定单笔订单实付满20元，本活动下单立返实付金额5%-15%无门槛优惠券。假设小超有1笔订单实付100元，则小超随机自动获得1张“5元至15元”无门槛优惠券至优惠券包。
                \n2）部分优惠券使用后，订单不参与后续优惠活动（如转盘、订单返券等），您可在“我的→我的优惠券”中查看优惠券详情，具体使用规则和有效时间信息详见券面信息。
                \n3）若您未理解本活动，请咨询客服微信：chaojicangku0001、supervault0002或chaojicangku003。`
      },
      textseven:{
        title:'分享获奖 参与方式&活动规则',
        texts: `一、参与方式
1、点击商品主页面右上方“···”，选择分享至微信好友或微信群。
2、邀请好友登录小程序为您助力。
3、好友点击、登录、助力后，视为一次成功分享。
4、奖品将自动发放至您的账户。
5、每位用户每日最多可发起助力的邀请/可为好友助力的次数限制，请以商品页面活动规则为准。
                \n二、活动规则
1、任何参与者通过不正当手段（包括但不限于作弊、干扰系统、侵犯其他人合法权益、实施网络攻击、用机器批量注册账户等方式）获得本活动奖品的，SuperVault（超级仓库）有权撤销奖品；造成严重影响的，SuperVault（超级仓库）有权通过法律渠道追责。
2、若用户曾经存在、出现或经SuperVault（超级仓库）合理怀疑或判定出现不当行为的，将可能被限制无法参与活动及使用/兑换已获得的奖品。
3、如遇不可抗力（包括但不限于活动存在严重干扰、大面积作弊行为、遭受严重网络攻击、因系统故障导致活动资格/奖品大批量出错等各类导致活动不能正常进行的情况时），SuperVault（超级仓库）有权取消、修改或暂停本活动。
4、若奖品为“开放选项奖品”（如奖品为同一版本但规格、颜色可选等情况），用户未在获奖后主动联系平台客服及平台客服联系用户无果的，SuperVault（超级仓库）有权随机发放对应该版本奖品。
5、若奖品为优惠券，用户可在“我的→我的优惠券”中查看，具体使用规则和有效时间详见券面信息。
                \n若您有疑问或未理解活动规则/奖品发放规则，请联系客服微信：chaojicangku0001，supervault0002或chaojicangku003`
      },
     }
  },
  methods: {
    goDetail(row) {
      if(row.type == 1) {
        if(isIos()) {
          window.webkit.messageHandlers.iOSCall.postMessage({
            action: "router",
            data: {
              url: `supervault://web?url=${prefix}/blindboxs/Turntableall?drawPrizeIds=${row.drawPrizeIds}`
            }
          })
        } else if(isAndroid()) {
          let par = {
            url: `supervault://web?url=${prefix}/blindboxs/Turntableall?drawPrizeIds=${row.drawPrizeIds}`
          }
          window.android.router(JSON.stringify(par))
        }
      }
    },
    clickmark(row) {
      this.maskVisible = true
      this.rowlist = row
      document.documentElement.style.overflowY = 'hidden'
    },
    maskClick(event) {
      if (event.target === this.$refs.mask) {
        this.maskVisible = false
        document.documentElement.style.overflowY = 'auto'
      }
    },
    gosharelist() {
      this.$router.push({name: 'RewardView', query:{token: this.sharetoken}})
    }
  }
}
</script>

<style scoped lang="scss">
.deliverWrap{
  width:100%;
  padding: .12rem;
  box-sizing: border-box;
  border-radius: .16rem;
  background: rgba(255, 255, 255, 0.08);
  position: relative;
  margin-top:.1rem;
  .typeName{
    height:.19rem;
    margin-top:-.1rem;
    // font-size:.18rem;
    // font-family: 'MyFont', sans-serif;
    // background: linear-gradient(to right, rgb(255, 186, 33) 10%, rgb(253, 217, 136) 13%, rgb(255, 186, 33) 16%, rgb(255, 186, 33) 21%, rgb(253, 217, 136) 21%, rgb(255, 186, 33) 24%);
    // -webkit-background-clip: text;
    // background-clip: text;
    // color: transparent;
    // font-weight: bold;
    // font-style: italic;
    // margin-bottom: .1rem;
  }
  .deliverMark{
    position: absolute;
    top:0;
    right:0;
    padding:.02rem .11rem;
    height:.16rem;
    font-size:.11rem;
    color:#fff;
    background: linear-gradient(90deg, rgba(40, 30, 91, 0.00) 0%, #452DBC 61.5%, #452DBC 100%);
    border-top-right-radius: .11rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .delivertextImg{
    // width:.72rem;
    height:.16rem;
    margin-top:-.1rem;
  }
  .goshare{
    width:1.32rem;
    height:.21rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background:url('https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/test/cover/101/5ec77921-502a-41fd-bd3d-0d17923692f7.png?height=72&width=560&size=32') no-repeat;
    background-size: 100% 100%;
    border-radius: .06rem;
    text-align: center;
    margin-left:.1rem;
    margin-top:-.1rem;
  }
  .deliverContent{
    width:100%;
    padding:.08rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background:url('../assets/backcard.png') no-repeat;
    background-size: 100% 100%;
    margin-top:.05rem;
    justify-content: space-between;
    .deliverContenttext{
      font-size:.13rem;
      color:rgba(255, 255, 255, 1);
      line-height: .18rem;
    }
    .deliverContentright{
      width:.18rem;
    }
  }
}
.markBox{
    width:100%;
    height:100%;
    background: rgba(6, 5, 24, 0.40);
    backdrop-filter: blur(10px);
    position: fixed;
    top:0;
    left:0;
    z-index:1;
    .content{
      width:100%;
      position: absolute;
      bottom:0;
      left:0;
      height: 3.75rem;
      background: url('../assets/backtwo.png') no-repeat;
      background-size:100% 100%;
      padding:.16rem;
      font-size:.13rem;
      color:#fff;
      animation: slideInFromBottom 0.3s ease;
      animation-fill-mode: forwards;
      opacity: 0;
      transform: translateY(100%);
      @keyframes slideInFromBottom {
        0% {
          opacity: 0;
          transform: translateY(100%);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .topfenge{
        width:.4rem;
        height:.05rem;
        background:#fff;
        border-radius: .05rem;
        margin-left: 1.5rem;
        margin-bottom: .3rem;
        margin-top: .1rem;
      }
      .title{
        text-align: center;
        font-size:.17rem;
      }
      .texts{
        width:100%;
        height: 2.8rem;
        overflow-y: scroll;
        scrollbar-width: none;
        white-space: pre-wrap;
        text-align: justify;
        line-height:.24rem;
        padding-bottom:.2rem;
        box-sizing: border-box;
      }
    }
  }
</style>